import { DropdownMenu } from './components/DropdownMenu/DropdownMenu';
import { DropdownMultiple } from './components/DropdownMultiple/DropdownMultiple';
import { DropdownNativeSelect } from './components/DropdownNativeSelect/DropdownNativeSelect';
import { DropdownResources } from './components/DropdownResources/DropdownResources';
import {
  GoogleFontDropdown,
  GoogleFontViewer,
} from './components/GoogleFontDropdown';
import Select from './components/Select/Select';
import { SelectCheckbox } from './components/SelectCheckbox/SelectCheckbox';

export const Dropdown = {} as {
  Menu: typeof DropdownMenu;
  Multiple: typeof DropdownMultiple;
  Native: typeof DropdownNativeSelect;
  Resources: typeof DropdownResources;
  GoogleFont: typeof GoogleFontDropdown & { Viewer: typeof GoogleFontViewer };
  Select: typeof Select;
  SelectCheckbox: typeof SelectCheckbox;
};

Dropdown.Menu = DropdownMenu;
Dropdown.Multiple = DropdownMultiple;
Dropdown.Native = DropdownNativeSelect;
Dropdown.Resources = DropdownResources;
Dropdown.GoogleFont = Object.assign(GoogleFontDropdown, { Viewer: GoogleFontViewer });
Dropdown.Select = Select;
Dropdown.SelectCheckbox = SelectCheckbox;
